import { plural } from '@cian/utils';
import { createSelector } from '@reduxjs/toolkit';
import { selectBedsValue } from './selectBedsValue';

export const selectBedsLabel = createSelector(
  selectBedsValue,
  value => `${value} ${plural(value, ['гость', 'гостя', 'гостей'])}`,
);
